import api from './api';

export interface SessionContainer {
  id: number;
  title: string;
  description: string;
  parent: number | null;
  thumbnail: number | null;
  thumbnail_url: string | null;
  created_by: number;
  created_at: string;
  updated_at: string;
  order: number;
  children_count: number;
  sessions_count: number;
}

class SessionContainerService {
  async getContainers(parentId: number | null = null): Promise<SessionContainer[]> {
    const params = parentId === null ? { parent: 'null' } : { parent: parentId };
    const response = await api.get('/session-containers/', { params });
    // Handle paginated response
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<SessionContainer> {
    const response = await api.get(`/session-containers/${id}/`);
    return response.data;
  }

  async getContainerContents(id: number): Promise<{ containers: SessionContainer[], sessions: any[] }> {
    const response = await api.get(`/session-containers/${id}/contents/`);
    return response.data;
  }

  async createContainer(data: Partial<SessionContainer>): Promise<SessionContainer> {
    const response = await api.post('/session-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<SessionContainer>): Promise<SessionContainer> {
    const response = await api.patch(`/session-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/session-containers/${id}/`);
  }

  async reorderContainers(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/session-containers/reorder/', { items });
  }
}

const sessionContainerService = new SessionContainerService();
export default sessionContainerService;
